//Imports
import * as React from 'react';
import "./components.css"

//Footer Function Starts
export default function Footer(){
    return(
        <div className="App-footer" >
            <p className={"Footertext"}>www.muscholl.com</p>
        </div>
    );



}